import { FETCH_DEALS } from '../actions/index';
import { ADD_DEAL } from '../actions/deals';

export default function(state = null, action) {
  switch (action.type) {
  case FETCH_DEALS:
    return action.payload;
  case ADD_DEAL:
    return [action.deal, ...state];
  default:
    return state;
  }
}
